












































import { useCustomersStore } from "@/store/useCustomersStore";
import { BFormCheckbox, BFormGroup, BFormInput } from "bootstrap-vue";
import { storeToRefs } from "pinia";
import { ref, Ref } from "@vue/composition-api";

export default {
    components: { BFormInput, BFormGroup, BFormCheckbox },
    setup() {
        const { customerSettings, editableCustomerSettings } = storeToRefs(useCustomersStore());

        editableCustomerSettings.value.push("customDataRetentionDays");

        const customDataRetentionDaysEnabled: Ref<boolean> = ref(customerSettings.value.customDataRetentionDays > 0);

        const onChangeCustomDataRetentionDaysEnable = (): void => {
            if (!customDataRetentionDaysEnabled.value) {
                customerSettings.value.customDataRetentionDays = 0;
            }
        };

        return {
            customerSettings,
            customDataRetentionDaysEnabled,
            onChangeCustomDataRetentionDaysEnable,
        };
    },
};
